// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* General styles linked to jsx */\n.general_headerTitle__Haa55 {\n    padding: 20px;\n    text-align: center;\n}", ""]);
// Exports
exports.locals = {
	"headerTitle": "general_headerTitle__Haa55"
};
module.exports = exports;
